import React from 'react'

const BuildingIcon = props => (
  <svg viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.0749 7.86194H9.73214V8.91667H0.267853V7.86194H0.925095V6.93906H1.84523V3.77488H0.925095V2.76809L5 0.083334L9.0749 2.76809V3.77488H8.15476V6.93906H9.0749V7.86194ZM7.10317 3.77488H5.52579V6.93906H7.10317V3.77488ZM4.4742 3.77488H2.89682V6.93906H4.4742V3.77488Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-16.1654"
        y1="-12.5968"
        x2="10.7461"
        y2="9.40789"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default BuildingIcon
